/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import { Helmet } from 'react-helmet-async';

const OrganizationSchema = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Nube iO",
        url: "https://nube-io.com",
        logo: "https://nube-io.com/logo.png",
        contactPoint: {
            "@type": "ContactPoint",
            telephone: "+61 2 7906 8414",
            contactType: "customer service",
            areaServed: "Global",
            availableLanguage: ["English"]
        },
        sameAs: [
            "https://www.linkedin.com/company/nube-io/?originalSubdomain=au",
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schemaData)}
            </script>
        </Helmet>
    );
};

export default OrganizationSchema;
